/*
 **	iOS-style List Section Component
 **	OMNI_IQ Mobile (c) 2025 Silver Falls Capital. All Rights Reserved
 */

import React from 'react'
import { OCAColors, Typography, Spacing, BorderRadius } from '../../theme/colors'

interface IOSListSectionProps {
  title?: string
  children: React.ReactNode
  footer?: string
}

export const IOSListSection: React.FC<IOSListSectionProps> = ({
  title,
  children,
  footer
}) => {
  return (
    <div style={{ marginBottom: Spacing.sm }}>
      {/* Section Header */}
      {title && (
        <div style={{
          padding: `12px ${Spacing.lg}`,
          paddingBottom: Spacing.xs,
          fontSize: Typography.fontSize.xs,
          fontWeight: Typography.fontWeight.normal,
          color: OCAColors.primaryLight, // Light blue for visibility on dark background
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
        }}>
          {title}
        </div>
      )}

      {/* Section Content */}
      <div style={{
        background: 'rgba(215, 215, 225, 0.7)',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        borderRadius: BorderRadius.lg,
        overflow: 'hidden',
        margin: `0 ${Spacing.md}`,
        // Enhanced shadow for liquid glass effect
        boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1), 0px 1px 3px rgba(0, 0, 0, 0.06)',
      }}>
        {children}
      </div>

      {/* Section Footer */}
      {footer && (
        <div style={{
          padding: `${Spacing.xs} ${Spacing.lg}`,
          paddingTop: Spacing.sm,
          fontSize: Typography.fontSize.xs,
          color: OCAColors.tertiaryLabel,
          lineHeight: '16px',
        }}>
          {footer}
        </div>
      )}
    </div>
  )
}